import { defineMessages } from 'react-intl';

/** Shared BAA / compliance kit checkbox copy for signup surfaces (single Crowdin unit per string). */
export const signupComplianceCheckboxesMessages = defineMessages({
  baaCheckbox: {
    defaultMessage: 'I require a signed BAA to remain HIPAA compliant',
    id: 'rHwbhfnazL',
    description: 'Label for HIPAA BAA requirement checkbox on signup',
  },
  complianceKitCheckbox: {
    defaultMessage: 'Receive documents on data protection & patient safety',
    id: 'lw4EbtxEGt',
    description: 'Label for compliance kit opt-in checkbox on signup',
  },
});
